import React, { useState, useRef } from 'react';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faFileUpload } from '@fortawesome/free-solid-svg-icons/faFileUpload';

import ModalFileAlert from './ModalFileAlert.jsx';

import { validateFiles } from '../helpers';

const FileDrop = ({
  children,
  className = 'pos-abs-fill',
  onDrop = () => {},
  accept,
  maxSize,
}) => {
  const [backdrop, setBackdrop] = useState(false);
  const [alert, setAlert] = useState(false);
  // account for dragging between parent and children
  const dragIn = useRef(0);

  return (
    <div
      className={className}
      onDragEnter={() => {
        dragIn.current += 1;
        if (!backdrop) setBackdrop(true);
      }}
      onDragLeave={() => {
        dragIn.current -= 1;
        if (dragIn.current === 0 && backdrop) setBackdrop(false);
      }}
      onDragOver={(e) => e.preventDefault()}
      onDrop={(e) => {
        e.preventDefault();
        setBackdrop(false);
        dragIn.current = 0;

        const { files } = e.dataTransfer;

        if (process.env.NODE_ENV !== 'production') {
          console.log('[FileDrop] onDrop', {
            count: files.length,
            names: Array.from(files).map((f) => f.name),
          });
        }

        const err = validateFiles(files, { accept, maxSize });

        if (err) {
          setAlert(err);
          return;
        }

        onDrop(files);
      }}
    >
      {children}
      {backdrop && (
        <div className="file-drop">
          <div className="pos-abs-center text-white display-4">
            <FA icon={faFileUpload} />
          </div>
        </div>
      )}
      {(accept || maxSize) && (
        <ModalFileAlert
          show={alert}
          onHide={() => setAlert(false)}
          accept={accept}
          maxSize={maxSize}
        />
      )}
    </div>
  );
};

export default FileDrop;
